import { createContext } from "react";
import {
  ShipmentConfirmContextValue,
  ShipmentDeleteContextValue,
  ShipmentDetailsContextValue,
} from "./types";

// ------ SHIPMENT DETAILS ---------
export const ShipmentDetailsContext = createContext<
  ShipmentDetailsContextValue | undefined
>(undefined);

// ------ SHIPMENT DELETE ---------
export const ShipmentDeleteContext = createContext<
  ShipmentDeleteContextValue | undefined
>(undefined);

// ------ SHIPMENT CONFIRM ---------
export const ShipmentConfirmContext = createContext<
  ShipmentConfirmContextValue | undefined
>(undefined);
